import { useState } from 'react';
import { useMediaQuery } from '../lib/use-media-query';
import { NARROW_QUERY } from './breakpoints';

/**
 * Below Tailwind's `lg` the rail starts collapsed, so tables keep their width on
 * small laptops. A toggle holds only until the window crosses that breakpoint.
 */
export function useSidebarCollapsed() {
  const narrow = useMediaQuery(NARROW_QUERY);
  const [override, setOverride] = useState<{ narrow: boolean; collapsed: boolean } | null>(null);
  const collapsed = override?.narrow === narrow ? override.collapsed : narrow;

  return { collapsed, toggle: () => setOverride({ narrow, collapsed: !collapsed }) };
}
